import {NetInfoState} from '@react-native-community/netinfo/src/internal/types';
import {NetworkActionTypes, NetworkPayload} from '@fkhplus/common/src/modules/network/actions';
import { ISetNetworkResponse } from '@fkhplus/common/src/modules/network/interfaces';
import { IFluxStandardAction } from '@fkhplus/common/src/modules/interfaces';

export interface INetworkState {
  isConnected: boolean;
  network?: NetInfoState;
  error : string
}

export const initialNetworkState: INetworkState = {
  isConnected: false,
  error : ''
};

export const NetworkReducer = (
    state: ISetNetworkResponse = initialNetworkState, 
    action: IFluxStandardAction<NetworkPayload>) : ISetNetworkResponse => {
    switch(action.type) {
        case NetworkActionTypes.IS_CONNECTED :
            return{
                ...state,
                ['isConnected']: action.payload as boolean
            };

        default:
            return state;
    }
};